import React, { Component } from 'react'
import store from 'services/store'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { CustomEventActionCreators } from 'app/reducers/CustomEventRedux'
import { getAddingOrEditingCustomEvent } from 'selectors/customEvent'
import { Modal } from 'controls'
import CustomEventForm from 'components/Forms/CustomEvent/ConnectedCustomEventForm'

class CustomEventModal extends Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.createAppointmentRequest.loading &&
      nextProps.createAppointmentRequest.finished &&
      !nextProps.createAppointmentRequest.error
    ) {
      this.close()
    }

    if (
      this.props.updateAppointmentRequest.loading &&
      nextProps.updateAppointmentRequest.finished &&
      !nextProps.updateAppointmentRequest.error
    ) {
      this.close()
    }
  }

  close = () => {
    this.props.actions.setEvent(null)
    this.props.actions.setEventType(null)
    this.props.actions.setSlotInfo(null)
    this.props.actions.setAddingOrEditingCustomEvent(false)
  }

  render() {
    const { addingOrEditingCustomEvent } = this.props

    return (
      <Modal
        isOpen={addingOrEditingCustomEvent}
        onClose={this.close}
        width="100%"
        maxWidth="540px"
        coverOnMobile
        position="top"
      >
        <CustomEventForm />
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  addingOrEditingCustomEvent: getAddingOrEditingCustomEvent(state),
  updateAppointmentRequest: store.patch('appointment').selector(state),
  createAppointmentRequest: store.create('appointment').selector(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setEvent: CustomEventActionCreators.setEvent,
      setEventType: CustomEventActionCreators.setEventType,
      setSlotInfo: CustomEventActionCreators.setSlotInfo,
      setAddingOrEditingCustomEvent:
        CustomEventActionCreators.setAddingOrEditingCustomEvent
    },
    dispatch
  )
})

export default connect(mapStateToProps, mapDispatchToProps)(CustomEventModal)
